import type { BotConfig } from "@investhinks/api-client";

/** Advisory only: the controller validates fresh positions, owners and writes atomically. */
export function v6TransitionNotice(original: Partial<BotConfig> | null | undefined, draft: Partial<BotConfig> | null): "positions" | "pause" | "verification" | null {
  if (!original?.id || !draft || (original.strategy?.name !== "V6FX" && draft.strategy?.name !== "V6FX")) return null;
  const before = original.userConfig || {}, after = draft.userConfig || {};
  const changed = original.strategy?.id !== draft.strategy?.id || before.risk !== after.risk ||
    JSON.stringify(before.assets) !== JSON.stringify(after.assets);
  if (!changed) return null;
  if (typeof original.stats?.openTrades === "number" && original.stats.openTrades > 0) return "positions";
  if (original.disabled !== true || draft.disabled !== true) return "pause";
  return "verification";
}
